import { render } from "./VideoCard.vue?vue&type=template&id=2b69cfd6&scoped=true"
import script from "./VideoCard.vue?vue&type=script&lang=js"
export * from "./VideoCard.vue?vue&type=script&lang=js"

import "./VideoCard.vue?vue&type=style&index=0&id=2b69cfd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b69cfd6"]])

export default __exports__